import envConfig from "../config/config";

const msalConfig = {
  auth: {
    clientId: envConfig.REACT_APP_CLIENT_ID,
    authority: envConfig.REACT_APP_AUTHORITY,
    redirectUri: envConfig.REACT_APP_REDIRECT_URL,
    // clientId: "f9d0e101-7342-42e8-8b1e-090941e6e4b3",
    // authority: 'https://login.microsoftonline.com/df7b3572-e484-4fcf-a072-6edd5d73f11f',
    // redirectUri: 'http://localhost:3000/dashboard/ui_repo', 
    postLogoutRedirectUri: "https://communityportal.devsuiteltts.com/",
    navigateToLoginRequestUrl: false
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: true
  }
};

export default msalConfig